import { type RouteRecordRaw } from 'vue-router'
import domeos from './domeos'
import redis from './redis'

export default [
  // 按模块对齐
  // 使用布局的路由
  {
    path: '/',
    component: () => import('../modules/home/layout.vue'),
    children: [
      // 首页
      {
        path: '',
        name: 'Home',
        component: () => import('../modules/home/home.vue'),
        meta: { title: '搜狐云-Panther' }
      },
      // 我的
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('../modules/home/profile.vue'),
        meta: { title: '我的' }
      }
    ]
  },
  ...domeos,
  ...redis,
  // 外部页面iframe
  {
    path: '/goto/outer',
    name: 'OuterPage',
    component: () => import('../modules/home/outer-page.vue'),
    meta: { title: '外部页面' }
  },
  // 公告详情页面
  {
    path: '/announcement/detail',
    name: 'AnnouncementDetail',
    component: () => import('../modules/home/announcement-detail.vue'),
    meta: { title: '公告详情' }
  },
  // 404页面
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('../components/NotFound/index.vue'),
    meta: { title: '页面未找到' }
  },
  // 通配符路由 - 必须放在最后
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
] satisfies RouteRecordRaw[]
